import React from 'react';

/**
 * Renders a string with *xxx* as bold (<strong>).
 * Use in dashboard builder and overlay content blocks (headers, text).
 */
export function renderTextWithBold(text: string): React.ReactNode {
  if (!text || typeof text !== 'string') return text;
  const parts = text.split(/(\*[^*]+\*)/g);
  return (
    <>
      {parts.map((part, i) =>
        part.startsWith('*') && part.endsWith('*') ? (
          <strong key={i}>{part.slice(1, -1)}</strong>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      )}
    </>
  );
}
